module.exports = __webpack_public_path__ + "static/Eat Bitter-7-868de66cbeb250837c8896bf82713272.jpg";